'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var deburrMap = new Map(Object.entries({
    Æ: 'Ae',
    Ð: 'D',
    Ø: 'O',
    Þ: 'Th',
    ß: 'ss',
    æ: 'ae',
    ð: 'd',
    ø: 'o',
    þ: 'th',
    Đ: 'D',
    đ: 'd',
    Ħ: 'H',
    ħ: 'h',
    ı: 'i',
    Ĳ: 'IJ',
    ĳ: 'ij',
    ĸ: 'k',
    Ŀ: 'L',
    ŀ: 'l',
    Ł: 'L',
    ł: 'l',
    ŉ: "'n",
    Ŋ: 'N',
    ŋ: 'n',
    Œ: 'Oe',
    œ: 'oe',
    Ŧ: 'T',
    ŧ: 't',
    ſ: 's'
}));
function deburr(str) {
    str = str.normalize('NFD');
    var result = '';
    for(var i = 0; i < str.length; i++){
        var char = str[i];
        if (char >= '\u0300' && char <= '\u036f' || char >= '\ufe20' && char <= '\ufe23') {
            continue;
        }
        var _deburrMap_get;
        result += (_deburrMap_get = deburrMap.get(char)) !== null && _deburrMap_get !== void 0 ? _deburrMap_get : char;
    }
    return result;
}
exports.deburr = deburr;
